import { type BettingInsightsContent, type EsIndex } from '~/configuration/types';
import { type BettingInsightsUI, type StyleSheet } from '~/configuration/ui/BettingInsightsUI';
import { type BookmakersConfig } from '~/vendor/cx-modules/types';
import { GridTable } from '~/vendor/cxy/components/GridTable';

type DefaultTableBodyProps<
  TIndex extends EsIndex,
  TContent extends BettingInsightsContent<TIndex> = BettingInsightsContent<TIndex>,
> = {
  bookmakers: BookmakersConfig;
  content: TContent;
  label: string;
  resultIndex: number;
  styles: StyleSheet;
  table: BettingInsightsUI<TIndex, TContent>['card']['table'];
};

export function DefaultTableBody<
  TIndex extends EsIndex,
  TContent extends BettingInsightsContent<TIndex> = BettingInsightsContent<TIndex>,
>({ bookmakers, content, label, resultIndex, styles, table }: DefaultTableBodyProps<TIndex, TContent>) {
  return (
    <GridTable.Body className={table.showAdditionalTitle ? styles.additionalTitle : ''}>
      <GridTable.Row>
        {table.cells.map((cell, cellIndex) => {
          return (
            <GridTable.Cell
              alignItems={cell.alignItems}
              className={cell.className ? styles[cell.className] : ''}
              highlight={cell.highlight && cell.highlight({ content })}
              isFullWidthMobile={cell.isFullWidthMobile}
              isMain={cell.isMain}
              justifyContent={cell.justifyContent}
              key={`${label}-cell-${cellIndex}`}
              order={cell.order}
              start={cell.start}
            >
              {cell.render({
                content,
                bookmakers,
                resultIndex,
              })}
            </GridTable.Cell>
          );
        })}
      </GridTable.Row>
    </GridTable.Body>
  );
}
